import { useEffect, useState } from 'react';

// null = jeszcze nie wiadomo (trwa sprawdzanie), true/false = ustalone
export const useIsPWA = (): boolean | null => {
    const [isPWA, setIsPWA] = useState<boolean | null>(null);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(display-mode: standalone)');
        const checkIfPWA = () => {
            setIsPWA(mediaQuery.matches);
        };
        checkIfPWA();
        mediaQuery.addEventListener('change', checkIfPWA);
        return () => mediaQuery.removeEventListener('change', checkIfPWA);
    }, []);

    return isPWA;
};
